import { getEligibleInterestActionTypesFilterOptions } from "@/modules/lead-page/api/lead-page.v2.api";
import { useQuery } from "@tanstack/react-query";

export const useEligibleInterestActionTypesFilterOptions = ({
  interestUid,
}: {
  interestUid: string;
}) => {
  const query = useQuery({
    queryKey: ["interest-action-types", interestUid],
    queryFn: () => getEligibleInterestActionTypesFilterOptions({ interestUid }),
  });
  return { ...query, data: query.data?.data };
};
